// src/components/wallet/MetaMaskButton.js
import React from 'react';
import { useWeb3React } from '@web3-react/core';
import { metaMask } from '../../web3/connectors';

const BASE_SEPOLIA = {
  chainId: '0x14A34', // 84532 in hex
  chainName: 'Base Sepolia',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: ['https://sepolia.base.org'],
  blockExplorerUrls: ['https://sepolia.basescan.org'],
};

export default function MetaMaskButton() {
  const { connector, isActive } = useWeb3React();
  const isMM = connector === metaMask;

  const ensureChain = async () => {
    const eth = window.ethereum;
    if (!eth) return;
    try {
      await eth.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: BASE_SEPOLIA.chainId }] });
    } catch (e) {
      if (e?.code === 4902) {
        await eth.request({ method: 'wallet_addEthereumChain', params: [BASE_SEPOLIA] });
      } else {
        throw e;
      }
    }
  };

  const connect = async () => {
    try {
      await metaMask.activate(84532);
    } catch (e) {
      await ensureChain();
      await metaMask.activate();
    }
  };

  if (isMM && isActive) return null;

  return (
    <button className="connect-banner-action connect-banner-action--mm" onClick={connect}>
      <img src="/assets/pgt-coin.png" alt="" className="connect-btn-icon" />
      Connect MetaMask
    </button>
  );
}
